import BaseService from '@/features/BaseService';

export default class TableManagerService extends BaseService {

  constructor() {
    super('tables-manager');
  }

}



// WEBPACK FOOTER //
// ./src/features/table-manager/TableManagerService.js